import store from '../store'

const { compact } = require('lodash')

const categoryMap = {
  necessary: 'C0001',
  analytics: 'C0002',
  functional: 'C0003',
  targeting: 'C0004',
  socialmedia: 'C0005',
  youtube: 'P0001',
}

updateStoreOnConsentChange(window.cookieHelperConsentedGroups)

if (!window.cookieHelperConsentUpdateHook) {
  window.cookieHelperConsentUpdateHook = updateStoreOnConsentChange
}

function updateStoreOnConsentChange(consentedGroups) {
  const newCookieConsents = consentedGroups || getActiveGroups()

  removeFirstPartyCookiesIfCategoryNotConsented(newCookieConsents)

  store.dispatch({
    type: 'UPDATE_COOKIE_CONSENT',
    cookieConsents: newCookieConsents,
  })
}

function revisitConsent() {
  if (window.OneTrust) {
    window.OneTrust.ToggleInfoDisplay()
  }
}

function getActiveGroups() {
  if (window.OnetrustActiveGroups) {
    return compact(window.OnetrustActiveGroups.split(','))
  }
  return []
}

function isCategoryConsented(category, stateConsentedGroups) {
  const categoryCode = categoryMap[category]
  // when consentedGroups is not provided from state, get it from OneTrust SDK
  const activeGroups = stateConsentedGroups || getActiveGroups()
  return activeGroups.includes(categoryCode)
}

function getCookieSettingsButtonText(options = {}) {
  if (isUnderCcpa()) {
    if (options.shortText) {
      return 'Your Privacy Choices'
    }
    return 'Do Not Sell Or Share My Personal Information'
  }
  return 'Cookie Settings'
}

function isUnderCcpa() {
  // For now we are disabling this the ccpa notif. in favor of having all users same experience
  // but we are keeping the code in case we need to enable it in the future
  // when the responsible authorities makes their mind.
  // if (window.OneTrust) {
  //   const oneTrustDomainData = window.OneTrust.GetDomainData()
  //   return oneTrustDomainData.CookieSettingButtonText.includes('Do Not Sell')
  // }
  return false
}

function isContentAllowed(contentType, stateConsentedGroups) {
  switch (contentType) {
    case 'youtube':
      return isCategoryConsented('youtube', stateConsentedGroups)
    default:
      return false
  }
}

function getApexDomain(hostname) {
  const parts = hostname.split('.')
  if (parts.length <= 2) return hostname
  return parts.slice(-2).join('.')
}

function removeFirstPartyCookiesIfCategoryNotConsented(consentedGroups) {
  const allCookies = document.cookie.split(';').map((cookie) => cookie.trim())
  const apexDomain = getApexDomain(window.location.hostname)

  if (!consentedGroups.includes(categoryMap.analytics)) {
    // Find and remove Google Analytics cookies
    allCookies.forEach((cookie) => {
      if (cookie.startsWith('_ga')) {
        const cookieName = cookie.split('=')[0]
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${apexDomain}`
      }
    })
    // Find and remove cdpDump analytics cookies
    allCookies.forEach((cookie) => {
      if (cookie.startsWith('ajs_')) {
        const cookieName = cookie.split('=')[0]
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${apexDomain}`
      }
    })
  }
}

export {
  isContentAllowed,
  revisitConsent,
  getCookieSettingsButtonText,
  isUnderCcpa,
}
